/**
 * Picks v2 or v1 of the Tapping Points page based on the redesign
 * flag. Same pattern as the other page switches.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import TappingPointsPage   from './TappingPointsPage';
import TappingPointsPageV2 from './TappingPointsPageV2';

export default function TappingPointsPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? TappingPointsPageV2 : TappingPointsPage;
  return <Component {...props} />;
}
